export enum EventType {
  SchoolStartDate = 1,
  EarlyReleaseDay = 2,
  LastDayOfSchool = 3,
  KeyDates = 4,
  Holiday = 5,
  BusEvacuationDrills = 6,
  CustomerInteraction = 7,
}
